import { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button, DatePicker } from 'components';
import { Field, Form, Formik } from 'formik';
import { PageTitle } from 'pages/Layout/PageTitle';
import { providersService } from 'services';
import XLSX from 'xlsx';

export const AlliedFat = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadReport = async (values) => {
    setIsLoading(true);
    toast.info('Aguarde um momento, Relatório está sendo gerado');

    try {
      const { data } = await providersService.getAlliedFat({
        input_data: values.input_data,
        output_data: values.output_data,
      });

      console.log('dados', data);

      if (data.length <= 0) {
        toast.error('Sem dados para exportar');
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = {
        Sheets: { AlliedFat: worksheet },
        SheetNames: ['AlliedFat'],
      };

      const now = new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-');
      XLSX.writeFile(workbook, `Relatorio_Allied_Fat_${now}.xlsx`);
      toast.success('Relatório gerado com sucesso!');
    } catch (error) {
      toast.error('Erro ao gerar o relatório.');
      console.error('Erro ao gerar o relatório.', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageTitle>Relatório Allied Faturamento</PageTitle>

      <Formik
        initialValues={{ input_data: new Date(), output_data: new Date() }}
        onSubmit={handleDownloadReport}
      >
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={2}>
              <Field
                size='small'
                name='input_data'
                disabled={isLoading}
                variant='inline'
                fullWidth
                inputVariant='outlined'
                label='Data inicial'
                component={DatePicker}
              />
            </Grid>
            <Grid item xs={12} lg={2}>
              <Field
                size='small'
                name='output_data'
                disabled={isLoading}
                variant='inline'
                fullWidth
                inputVariant='outlined'
                label='Data final'
                component={DatePicker}
              />
            </Grid>
            <Grid item xs={12} lg={2}>
              <Button type='submit' fullWidth loading={isLoading}>
                Exportar relatório
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </>
  );
};
